import type { SxProps, Theme } from '@mui/material';
import { designTokens } from '../tokens';

const inlinePadding = {
  xs: `${designTokens.layout.dialogContentPaddingCompact}px`,
  sm: `${designTokens.layout.dialogContentPadding}px`,
};
const blockPadding = `${designTokens.layout.dialogActionBlockPadding}px`;
const focusClearance = designTokens.space.xxs;

/** 가로 inset과 세로 간격을 분리하고 스크롤 본문 끝에도 바깥 초점 표시의 여유를 남깁니다. */
export function dialogHeadingStyles(dividers = false): SxProps<Theme> {
  return {
    position: 'relative',
    flexShrink: 0,
    px: inlinePadding,
    pt: blockPadding,
    pb: dividers ? `${designTokens.space.sm}px` : {
      xs: `${designTokens.layout.dialogSectionGapCompact - focusClearance}px`,
      sm: `${designTokens.layout.dialogSectionGap - focusClearance}px`,
    },
  };
}

export function dialogContentStyles({ dividers = false, actions = true, fill = false } = {}): SxProps<Theme> {
  const topPadding = `${dividers ? designTokens.space.sm : focusClearance}px`;
  return {
    minHeight: 0,
    flex: fill ? 1 : undefined,
    overflow: 'auto',
    px: inlinePadding,
    pt: topPadding,
    pb: actions ? topPadding : blockPadding,
    // MUI의 제목 바로 다음 본문 padding-top: 0 기본 규칙보다 명시적으로 적용합니다.
    '.MuiDialogTitle-root + &': { paddingTop: topPadding },
  };
}

export function dialogActionsStyles({ dividers = false, stackOnMobile = false, scrollDivider = false } = {}): SxProps<Theme> {
  return {
    flexShrink: 0,
    flexWrap: 'wrap',
    gap: `${designTokens.space.xs}px`,
    px: { xs: `${designTokens.space.md}px`, sm: blockPadding },
    pt: dividers ? `${designTokens.space.sm}px` : {
      xs: `${designTokens.layout.dialogSectionGapCompact - focusClearance}px`,
      sm: `${designTokens.layout.dialogSectionGap - focusClearance}px`,
    },
    pb: { xs: `${designTokens.space.md}px`, sm: blockPadding },
    ...(scrollDivider && !dividers ? {
      position: 'relative',
      // 스크롤 여부가 바뀌어도 본문 높이와 기존 작업 여백은 움직이지 않습니다.
      '&::before': {
        content: '""',
        position: 'absolute',
        insetInline: 0,
        top: 0,
        borderTop: `1px solid ${designTokens.color.divider}`,
        pointerEvents: 'none',
      },
    } : {}),
    ...(stackOnMobile ? {
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: { xs: 'stretch', sm: 'center' },
    } : {}),
  };
}
